import { render } from "./VesselPositions.vue?vue&type=template&id=7484a7e0&scoped=true"
import script from "./VesselPositions.vue?vue&type=script&lang=js"
export * from "./VesselPositions.vue?vue&type=script&lang=js"

import "./VesselPositions.vue?vue&type=style&index=0&id=7484a7e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7484a7e0"]])

export default __exports__